import React from "react";

const UnsupportedGateway = () => {
  return (
    <div className='piranha-payment-warning'>
      <strong>⚠️ Unsupported payment gateway</strong>
      <hr />
      <div>
        This plan has an unsupported payment gateway. Please choose another
        available payment gateway.
      </div>
    </div>
  );
};

export default UnsupportedGateway;
